import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { languageChange } from 'store/siteConfig'
import { Toast } from 'antd-mobile'
import queryString from 'query-string'
import { isPayBy } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const VOUCHER_COLLECT = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    COLLECT_REQUEST: null,
    COLLECT_SUCCESS: null,
    SHOW_PAGE: null
  },
  'VOUCHER_COLLECT'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    const { campaignId } = queryString.parseUrl(window.location.href).query
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: isPayBy()
          ? 'cgs/marketing-gateway/v1/auth/campaign/detail'
          : 'cgs/marketing-gateway/v1/unauth/campaign/detail',
        method: 'POST',
        body: { campaignId },
        requestAction: VOUCHER_COLLECT.INIT_REQUEST,
        successAction: VOUCHER_COLLECT.INIT_SUCCESS,
        success: function(result) {
          dispatch({
            type: VOUCHER_COLLECT.SHOW_PAGE
          })
        },
        error: function(result, msg) {
          Toast.info(msg, 2, () => {
            dispatch({
              type: VOUCHER_COLLECT.SHOW_PAGE
            })
          })
        }
      })
    )
  }
}

export function collect(couponId, errCallback) {
  Toast.loading('', 0)
  return (dispatch, getState) => {
    const { cmpnId } = getState().voucherCollectState.campaign
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing-gateway/v1/auth/campaign/coupon/collect',
        method: 'POST',
        body: {
          couponId,
          cmpnId
        },
        requestAction: VOUCHER_COLLECT.COLLECT_REQUEST,
        successAction: VOUCHER_COLLECT.COLLECT_SUCCESS,
        success: function(result) {
          const { code, message } = result
          Toast.info(code === 'SUCCESS' ? 'Collected successfully.' : message)
          code === 'SUCCESS' && dispatch(init())
        },
        error: function(result, msg) {
          if (result.head.code === 'ELIGIBLE_FOR_KYC') {
            Toast.hide()
            typeof errCallback === 'function' && errCallback()
          } else {
            Toast.info(msg, 2)
          }
        }
      })
    )
  }
}

export function showPage() {
  return (dispatch) => {
    dispatch({
      type: VOUCHER_COLLECT.SHOW_PAGE
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [VOUCHER_COLLECT.INIT_REQUEST]: (state, action) => state,
  [VOUCHER_COLLECT.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [VOUCHER_COLLECT.COLLECT_REQUEST]: (state, action) => state,
  [VOUCHER_COLLECT.COLLECT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [VOUCHER_COLLECT.SHOW_PAGE]: (state, action) =>
    Object.assign({}, state, { showPage: true })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'voucherCollect',
    reducerMap: {
      voucherCollectState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [languageChange('en')],
    // finalActions: []
  }
}
